<template>
  <Salesarchived />
</template>

<script>
import Salesarchived from "../../components/Sales/salesarchived.vue";

export default {
  components: { Salesarchived },
};
</script>
